export default __webpack_public_path__ + "c473c3060c4201232643ddc37bc512cb.png";